//components
import { StyledButton } from '../common/StyledButton';
import { useAuthContext } from '../../context/auth-context';

//css
import styled from 'styled-components';

/**
 * Cada acción declara el permiso que necesita. Sin él el botón no se pinta: llevar a
 * alguien a un formulario que el servidor va a rechazar con 403 solo gasta su tiempo.
 */
const authOptions = {
  AddUser: { label: 'Add User', perm: 'users.manage' },
  AssignJudgeEvent: { label: 'Asignar Juez a Evento', perm: 'rubrics.manage' },
};

const Options = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 2%;
  margin-bottom: 2%;
`;

export const GenerateAuthOptions = props => {
  const { handleClick } = props;
  const { hasPermission } = useAuthContext();

  return (
    <Options>
      {Object.entries(authOptions)
        .filter(([, { perm }]) => hasPermission(perm))
        .map(([item, { label }]) => (
          <StyledButton key={item} id={item} variant='contained' onClick={handleClick}>
            {label}
          </StyledButton>
        ))}
    </Options>
  );
};
